<template>
  <form
    ref="form"
    name="sAddToBasket"
    method="post"
    :action="`${$store.state.shopwareBaseUrl}/checkout/addArticle`"
    :data-addArticleUrl="`${$store.state.shopwareBaseUrl}/checkout/ajaxAddArticleCart`"
    data-add-article="true"
    data-eventname="submit"
    data-showmodal="false"
  >
    <input type="hidden" name="sAdd" :value="articleNumber" />
    <input type="hidden" name="sQuantity" :value="quantity" />
    <input type="hidden" name="sCompositionHash" :value="composition" />
    <button ref="button" type="submit"></button>
  </form>
</template>
<script>
import getJQuery from '../../utils/detect-global-jquery';
import Cookies from 'js-cookie';

export default {
  name: 'ShopwareBasketTrigger',
  props: {
    articleNumber: {
      type: String,
      default: ''
    },
    quantity: {
      type: Number,
      default: 1
    },
    composition: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    shopwareCartButton: undefined,
    $: undefined
  }),
  mounted() {
    this.$ = getJQuery();

    if (this.$) {
      this.shopwareCartButton = this.$(this.$refs.form);
      this.shopwareCartButton.swAddArticle();
    }
  },
  methods: {
    trigger() {
      if (this.$) {
        const me = this;

        this.$nextTick(() => {
          me.$(me.$refs.button).trigger('click');

          Cookies.remove('addedArticles');

          me.$router.push({
            name: 'root',
            params: { articleNumber: me.$route.params.articleNumber }
          });
        });
      }
    }
  }
};
</script>
